import React, { useEffect, ComponentProps, FunctionComponent, useState } from 'react';

import Cigarette from '../../components/Cigarette';

import { useGetApiClient } from '../../context/apiContext';
import { SearchLand } from '@lt/api/dist/methods/search/types';
import {
  useGetWhitelabelDomain,
  useGetBaseQueryParams,
  useConstructorContextState,
  useTracker,
} from '../../context/constructorContext';
import { createWidgetLink } from '../../utils';
import { Container, ContainerCigarette } from './styles';

import { useResizeDetector } from 'react-resize-detector';
import type { Props as ReactResizeDetectorProps } from 'react-resize-detector/build/ResizeDetector';
import { MIN_WIDTH, MIN_DESKTOP_CIGARETTE_WIDTH } from '../constants';
import { SEARCH_TYPE_NAMES } from '@lt/components/constants/search';
import { INITIAL_VALUES_FORMIK } from '../../components/Cigarette/constants';
import type { Values } from '../../components/Cigarette/context';
import SearchTypeTabs from '../../components/SearchTypeTabs';
import { TABS_PAGES } from '../../components/SearchTypeTabs/constants';
import type { SearchType } from '../../components/Cigarette/types';

const resizeDetectorConfig: ReactResizeDetectorProps = {
  handleHeight: false,
  handleWidth: true,
  refreshMode: 'throttle',
  refreshRate: 250,
  observerOptions: {
    box: 'border-box',
  },
};

type Props = ComponentProps<typeof Cigarette>;

/**
 * @desc сига с настройкой для использования в качестве виджета партнерами
 * */
const CigaretteWidget: FunctionComponent<Props> = (props) => {
  const api = useGetApiClient();
  const configState = useConstructorContextState();
  const whitelabelDomain = useGetWhitelabelDomain();
  const baseQueryParams = useGetBaseQueryParams();
  const trackerMethods = useTracker();

  const { search_type = props.searchType, departure = props.initialValues?.departure } =
    configState.searchParams || {};

  const { width = MIN_WIDTH, ref } = useResizeDetector(resizeDetectorConfig);
  const [searchTypeTabs, setSearchType] = useState<SearchType>(search_type);

  useEffect(() => {
    if (!trackerMethods) {
      return;
    }

    const { trackShow } = trackerMethods;
    trackShow();
  }, []);

  useEffect(() => {
    setSearchType(search_type);
  }, [search_type]);

  const handleChange = (values: Values, changes: Values) => {
    if (!trackerMethods) {
      return;
    }

    const { trackSearchParamsChange } = trackerMethods;
    trackSearchParamsChange(changes, values);
  };

  const getRedirectLink = async (values: SearchLand) => {
    // Чтобы не блокировалось всплывающее окно в Safari
    let newTabReference: WindowProxy | null = null;
    const openInNewTab = configState.redirect === '_blank';

    if (openInNewTab) {
      newTabReference = window.open();
    }

    const result = await api?.getSearchLand(
      Object.assign({}, values, {
        host: whitelabelDomain,
      })
    );

    const qs = Object.assign(
      {
        search_type,
      },
      baseQueryParams
    );
    if (!result?.redirect_url) {
      return;
    }

    const link = createWidgetLink(result.redirect_url, qs);

    if (newTabReference) {
      newTabReference.location.href = link;
    } else {
      window.location.href = link;
    }
  };

  const isMobile = width < MIN_DESKTOP_CIGARETTE_WIDTH || false;

  return (
    <ContainerCigarette>
      {configState.isTabsSwitchOn ? (
        <SearchTypeTabs
          selectedTab={searchTypeTabs}
          setSelectedTab={setSearchType}
          variant={{
            mobile: false,
            wl: false,
            collapsed: false,
            page: TABS_PAGES.MAIN,
          }}
        />
      ) : null}
      <Container
        $isBlankBackground={configState.isBlankBackground || false}
        $isMobile={isMobile}
        ref={ref}
      >
        <Cigarette
          mobileVariant={isMobile ? 'default' : undefined}
          searchType={searchTypeTabs || SEARCH_TYPE_NAMES.PACKAGE}
          initialValues={{
            ...INITIAL_VALUES_FORMIK,
            departure,
          }}
          onSubmit={getRedirectLink}
          onChange={handleChange}
          isWidget
        />
      </Container>
    </ContainerCigarette>
  );
};

export default CigaretteWidget;
